import React, { useContext } from 'react'
import { UserContext } from '../../stores/UserStore'
import { AppContext } from '../../stores/AppStore'
import Header from '../../components/layout/Header'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import AppLogo from 'assets/images/logo.png'

const AppHeader = () => {
  const { t } = useTranslation()
  const { pageTitle, pageSubtitle, isHeaderVisible } = useContext(AppContext)
  const { authState, signOut, currentUser } = useContext(UserContext)
  const history = useHistory()

  const sideMenuSettings = {
    appLogoSrc: AppLogo,
    itemGroups: [
      {
        key: 'no-header',
        items: [
          {
            key: 'no-header-entry',
            icon: 'apps',
            label: t('service.pageTitle'),
            onClick: () => history.push('/'),
          },
          {
            key: 'safety',
            icon: 'apps',
            label: t('safety.pageTitle'),
            onClick: () => history.push('/safety'),
          },
          {
            key: 'register',
            icon: 'apps',
            label: t('safety.registerNm'),
            onClick: () => history.push('/safety/register'),
          },
          {
            key: 'planning',
            icon: 'apps',
            label: t('safety.planning.title'),
            onClick: () => history.push('/safety/planning'),
          },
          {
            key: 'inspection-report',
            icon: 'apps',
            label: t('inspectionReport.pageTitle'),
            onClick: () => history.push('/inspection-report'),
          },
          //{
          //  key: 'field-data',
          //  icon: 'apps',
          //  label: t('fieldData.pageTitle'),
          //  onClick: () => history.push('/field-data'),
          //},
          //{
          //  key: 'field-manual-data',
          //  icon: 'apps',
          //  label: t('fieldManualData.pageTitle'),
          //  onClick: () => history.push('/field-manual-data'),
          //},
          //{
          //  key: 'vallourec-services-data',
          //  icon: 'apps',
          //  label: t('vallourecServicesData.pageTitle'),
          //  onClick: () => history.push('/vallourec-services-data'),
          //},
          //{
          //  key: 'vallourec-services-manual-data',
          //  icon: 'apps',
          //  label: t('vallourecServicesManualData.pageTitle'),
          //  onClick: () => history.push('/vallourec-services-manual-data'),
          //}, 
          //{
          //  key: 'vallourec-services-manual-data',
          //  icon: 'apps',
          //  label: t('transport.pageTitle'),
          //  onClick: () => history.push('/management-transport'),
          //},
        ],
      },
    ],
  }

  const userSettings = {
    username: currentUser ? currentUser.name : currentUser,
    options: [
      {
        key: 'version',
        label: 'v' + process.env.REACT_APP_VERSION,
        onClick: () => { },
      },
      {
        key: 'edit-profile',
        label: t('Edit Profile'),
        onClick: () =>
        (window.location.href =
          process.env.REACT_APP_HOME_URL + 'update-profile'),
        divider: true,
      },
      {
        key: 'sign-out',
        label: t('Sign Out'),
        onClick: signOut,
        divider: true,
      },
    ],
  }

  const home = {
    onClick: () => (window.location.href = process.env.REACT_APP_HOME_URL),
  }

  const apps =
    currentUser &&
    currentUser.applications.map((app) => {
      return {
        key: app.id,
        label: app.label,
        iconSrc: app.icon,
        onClick: () => (window.location.href = app.link),
      }
    })

  const redirectToHome = () =>
    (window.location.href = process.env.REACT_APP_HOME_URL)

  return isHeaderVisible && authState === 'SIGNED_IN' ? (
    <Header
      title={pageTitle}
      homeIcon={home}
      sideMenuSettings={sideMenuSettings}
      subtitle={pageSubtitle}
      // appIconSrc={LogoImg}
      onAppIconClick={redirectToHome}
      userSettings={userSettings}
      apps={apps}
    />
  ) : null
}

export default AppHeader
